import { jsx as a } from "react/jsx-runtime";
import o from "../../utils/classNames.js";
const c = ({ className: t, ...r }) => {
  const s = o("ActionBarItemListSeparator", t);
  return /* @__PURE__ */ a("hr", { ...r, className: s });
};
export {
  c as default
};
//# sourceMappingURL=ActionBarItemListSeparator.js.map
